import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=f7a2ad06&scoped=true&"
import script from "./serviceDetails.vue?vue&type=script&lang=js&"
export * from "./serviceDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=f7a2ad06&scoped=true&lang=css&"
import style1 from "./serviceDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a2ad06",
  null
  
)

export default component.exports